// extracted by mini-css-extract-plugin
export default {"terms":"SignUp_terms__9HZUW","validationError":"SignUp_validationError__oLQhg","referralHint":"SignUp_referralHint__ktjnm"};